import { FC } from 'react';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Control, FieldErrors } from 'react-hook-form';
import { WaterfallFormModel, WaterfallViewModel } from '../../models/waterfall';
import { FormDropdown } from '../../components/form';

interface VersionControlsProps {
  waterfall: WaterfallViewModel;
  control: Control<WaterfallFormModel>;
  errors: FieldErrors<WaterfallFormModel>;
  selectedVersion?: number | null;
  isSubmitting: boolean;
  versionOptions: { label: string; value: number }[];
  onDuplicate: () => void;
  onActivate: () => void;
  onDelete: () => void;
}

export const VersionControls: FC<VersionControlsProps> = ({
  waterfall,
  control,
  errors,
  selectedVersion,
  isSubmitting,
  versionOptions,
  onDuplicate,
  onActivate,
  onDelete,
}) => {
  const disable = isSubmitting || !selectedVersion || selectedVersion === waterfall.currentVersionId;

  return (
    <>
      <FormDropdown
        control={control}
        errors={errors}
        field="selectedVersion"
        label="Select Version"
        options={versionOptions}
        placeholder="Select Version"
      />

      <div className="flex flex-row gap-2">
        <Button
          icon="pi pi-clone"
          className="p-button-rounded p-button-text"
          tooltip="Duplicate Version"
          tooltipOptions={{ position: 'top', showDelay: 500, hideDelay: 0 }}
          type="button"
          onClick={onDuplicate}
          disabled={isSubmitting || !selectedVersion}
        />
        <Button
          icon="pi pi-check-circle"
          className={classNames('p-button-rounded p-button-text', { 'opacity-50': disable })}
          tooltip="Set Active"
          tooltipOptions={{ position: 'top', showDelay: 500, hideDelay: 0 }}
          severity="success"
          type="button"
          onClick={onActivate}
          disabled={disable}
        />
        <Button
          icon="pi pi-trash"
          className={classNames('p-button-rounded p-button-text', { 'opacity-50': disable })}
          tooltip="Delete Version"
          tooltipOptions={{ position: 'top', showDelay: 500, hideDelay: 0 }}
          severity="danger"
          type="button"
          onClick={onDelete}
          disabled={disable}
        />
      </div>
    </>
  );
};
